import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'jobCardTimedif' 
})
export class JobCardTimedifPipe implements PipeTransform {

  transform(minute: number): string {
    var textReturn = "";


    if (minute < 60) {
      if (minute <= 1) {
        textReturn = minute.toString().concat(" minuto");
      }
      else {
        textReturn = minute.toString().concat(" minutos");
      }
    }
    else if (minute < 1440) {
      var hour = Math.round((minute / 60));
      if (hour <= 1) {
        textReturn = hour.toString().concat(" hora");

      }
      else {
        textReturn = hour.toString().concat(" horas");
      }
    }
    else {
      var day = Math.round((minute / 1440));
      if (day <= 1) {
        textReturn = day.toString().concat(" día");

      }
      else {
        textReturn = day.toString().concat(" días");
      }
    }

    return textReturn;
  }
}
